<template>
  <div
    :key="value.id"
    class="application-dialog_item"
    :class="{'active': active}"
    @click="$emit('click')">
    <slot/>
    <UserIcon
      class="avatar mr-2 ml-2"
      :name="typeof value.name === 'string' ? value.name : (typeof value.fullName === 'string' ? value.fullName : (typeof value === 'string' ? value : ''))"
      size="33"
      :src="value.avatar"/>
    <div v-if="value.secondName || value.fullName">
      <PersonTooltip
        class="mb-1"
        :department="value.department"
        :name="value.secondName ? value.secondName + '  ' + value.firstName : value.fullName "/>
      <div
        class="font-size-12"
        style="color: rgba(0, 0, 0, 0.6);">
        {{ value.department ? value.department.name : $t('Common.NoData') }}
      </div>
    </div>
    <div
      v-else
      class="mb-2">
      {{ value }}
    </div>
  </div>
</template>
<script>
import UserIcon from 'components/header/UserIcon.vue'
import PersonTooltip from 'components/common/blocks/PersonTooltip.vue'

export default {
  name: 'applicantsDialogItem',
  props: {
    value: Object,
    active: Boolean
  },
  components: {
    UserIcon,
    PersonTooltip,
  }
}
</script>
<style scoped lang="scss">

.application-dialog {
  &_item {
    color: var(--text-color);
    height: 70px;
    border-bottom: 1px solid var(--v-main__green-base);
    cursor: pointer;
    align-items: center;
    display: flex;
    letter-spacing: normal;
    min-height: 48px;
    padding: 0 16px 0 8px;
    position: relative;
    &:last-child {
      border-bottom: none;
    }
    &:before {
      background-color: currentColor;
      bottom: 0;
      content: "";
      left: 0;
      opacity: 0;
      pointer-events: none;
      position: absolute;
      right: 0;
      top: 0;
      transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    }
    &:hover::before,
    &.active::before {
      opacity: 0.12;
    }
  }
}
</style>
